<template>
  <div class="house-importer-checklist-row" :class="{'house-importer-checklist-row_active':active}">
    <div class="house-importer-checklist-row__icon" @click="toggleActive">
      <app-icon name="CheckIcon" size="20px"/>
    </div>
    <label class="house-importer-checklist-row__label" @click="toggleActive">{{title}}</label>
  </div>
</template>

<script>
  export default {
    name: "ChecklistRow",
    props: {
      title: {},
      importInfo: {},
      objKey: {}
    },
    data(){
      return {
        active: false
      }
    },
    methods: {
      async toggleActive(){
        this.active = !this.active;

        let body = {
          import_id: this.importInfo.id,
          check_key: this.objKey,
          check_value: this.active,
        };

        try{
          await this.$http.put('/import/houses/check_list', body);
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.active = !this.active;
        }
      }
    },
    mounted() {
      this.active = this.importInfo.check_list[this.objKey];
    }
  }
</script>

<style lang="scss">
  .house-importer-checklist-row {
    display: flex;
    align-items: center;

    &__label{
      position: relative;
      display: inline-flex;
      align-items: center;
      padding: 0 5px;
      line-height: 1;
      cursor: pointer;
      user-select: none;
      color: rgba(var(--app-text-muted), 1);
      transition: all .3s ease;
      font-weight: 500;
      font-size: 18px;

      &::after{
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 0%;
        height: 2px;
        transition: all .3s ease;
        background: rgba(var(--app-success), 1);
      }
    }

    &__icon{
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 5px;
      cursor: pointer;
      color: rgba(var(--app-text-muted), 1);
      transition: all .3s ease;
      margin-top: -1px;
    }

    &_active{
      .house-importer-checklist-row{

        &__label{
          color: rgba(var(--app-text-muted), 1);
          &::after{
            width: 100%;
          }
        }

        &__icon{
          color: rgba(var(--app-success), 1);
        }
      }
    }
  }
</style>